<template>
  <div>
    <div style="padding: 0 50px 100px 50px">
      <div style="line-height: 4;" v-if="data">
        <Form :label-width="120" ref="formData" :rules="formRules" :model="data" label-position="left">
          <FormItem label="解约房间">
            <span>{{data.projectName}}-</span><span>{{data.stockNumber}}</span>
          </FormItem>
          <FormItem label="解约类型">
            <span>{{data.surTypeName || '-'}}</span>
          </FormItem>
          <FormItem label="解约申请日期">
            <span>{{formatDateTime(data.surApplicationDate,false)}}</span>
          </FormItem>
          <FormItem label="合同租期">
            <span>{{formatDateTime(data.conStartDate,false)}}</span> 至
            <span>{{formatDateTime(data.conEndDate,false)}}</span>
          </FormItem>
          <FormItem label="实际租期">
            <span>{{formatDateTime(data.conStartDate,false)}}</span> 至
            <span>{{formatDateTime(data.surRentPriceDate,false)}}</span>
          </FormItem>
          <FormItem label="退租后房态" prop="stockStatus" class="notip">
            <Select class="width250" v-model="data.stockStatus">
              <Option value="">请选择</Option>
              <Option v-for="(item,index) in list1" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="可出租日期" prop="stockRentDate">
            <DatePicker class="width250" :disabled="disabledRentDate" v-model="stockRentDate" type="date" :options="stockRentDateOption" placeholder="请选择日期"></DatePicker>
          </FormItem>
          <FormItem label="解约原因类型" prop="surReasonType" class="notip">
            <Select class="width250" v-model="data.surReasonType">
              <Option value="">请选择</Option>
              <Option v-for="(item,index) in data.surReasons" :value="item.value" :key="'keyK'+index">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="解约原因" prop="surReason" class="notip" v-if="data.surReasonType==6">
            <Input class="width250" v-model="data.surReason"/>
          </FormItem>
          <FormItem label="换租合同信息" prop="changeContractCode"  v-if="data.surType===4||data.surType===11||data.surType===12||data.surType===13||data.surType===14">
            <Input placeholder="新签合同号" class="width250" @on-blur="validContract" v-model="data.changeContractCode"/>
          </FormItem>
          <div v-if="data.surType===5">
            <FormItem label="转租人姓名" prop="subletCustomerName" >
              <Input class="width250" v-model="data.subletCustomerName"/>
            </FormItem>
            <FormItem label="转租人证件类型" prop="subletCardType" >
              <Select placeholder="" v-model="data.subletCardType" class="width250">
                <Option value="">请选择</Option>
                <Option v-for="(item,index) in list2" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
              </Select>
            </FormItem>
            <FormItem label="" prop="" label="转租人证件号" prop="subletCustomerCertNum" >
              <Input class="width250"  v-model="data.subletCustomerCertNum">
              </Input>
            </FormItem>
            <FormItem label="转租人电话" prop="subletCustomerPhone" >
              <Input placeholder="" class="width250" v-model="data.subletCustomerPhone"/>
            </FormItem>
          </div>
        </Form>
      </div>
    </div>
    <div class="a1">
      <!--<Button type="default" style="margin-right: 50px" @click.stop="cancel">取消</Button>-->
      <Button type="primary" @click.stop="toNext">下一步</Button>
    </div>
    <config-detail :n="n"></config-detail>
  </div>
</template>
<script>
  import ConfigDetail from './ConfigDetail'
  import {
    getEnterpriseSurrenderInitInfo,
    epsbaseupdate, validChangeRentContract
  } from "../../../../../api/contractList";
  import {formatDateTime} from "../../../../../utils/format";
  import stockStatus from '../../mixins/stockStatus';

  export default {
    name: "ReleaseInfo",
    mixins: [stockStatus],
    components: {
      ConfigDetail
    },
    props:{
      data:{
        type:Object,
        default:null
      },
      list2:{
        type:Array,
        default: []
      }
    },
    data() {
      return {
        contractId: '',
        list1: [{text: '待租中', value: 0}, {text: '配置中', value: 3}],
        list3: [{text: '新', value: 0}, {text: '旧', value: 1}],
        list4: [{text: '正常', value: 0}, {text: '损坏', value: 1}],
        formRules: {
          changeContractCode: [
            {required: true, message: '请输入新签合同号', trigger: 'blur', type: 'string'}
          ],
          subletCustomerName: [
            {required: true, message: '请输入转租人姓名', trigger: 'blur', type: 'string'}
          ],
          subletCustomerCertNum: [
            {required: true, message: '请输入转租人身份证号', trigger: 'blur', type: 'string'}
          ],
          subletCustomerPhone: [
            {required: true, message: '输入正确的手机号', trigger: 'blur', validator: this.validatecontactPhone2}
          ],
          subletCardType: [
            {required: true, message: '请选择转租人证件类型', trigger: 'change', validator: this.validateNumber}
          ],
          stockStatus: [
            {required: true, message: '请选择退租后房态', trigger: 'change', validator: this.validateNumber}
          ],
          stockRentDate: [
            {required: true, message: '请选择可出租日期', trigger: 'change', type: 'date', validator: this.validateDate},
          ],
          surReason:[
            {required: true, message: '请输入解约原因', trigger: 'blur', type: 'string'}
          ],
          surReasonType:[
            {required: true, message: '请选择解约原因类型', trigger: 'change', validator: this.validateNumber}
          ],
        },
        n: 0,
      }
    },
    computed:{
      surReasonsMap(){
        if(!this.data){
          return {}
        }
        let ret={}
        this.data.surReasons.forEach(ele=>{
          ret[ele.value+'']=ele.text
        })
        return ret
      }
    },
    methods: {
      validatecontactPhone2(rule, value, callback) {
        let pattern = /^1\d{10}$/
        if (!pattern.test(value)) {
          callback(new Error('输入正确的手机号'));
        }
        callback();
      },
      cancel(){
        this.$refs['formData'].resetFields()
      },
      formatDateTime: formatDateTime,
      epsbaseupdate() {
        if(this.data.surReasonType!==6){
          this.data.surReason=this.surReasonsMap[this.data.surReasonType]
        }

        let params = {
          "changeRentContractCode": this.data.changeContractCode,
          "parentSurrenderFid": this.data.parentSurrenderFid,
          "rentPriceDate": this.data.surRentPriceDate,
          "stockFid": this.data.stockFid,
          "stockStatus": this.data.stockStatus,
          stockRentDate: formatDateTime(this.data.stockRentDate, false),
          "subletCardType": this.data.subletCardType,
          "subletCustomerCertNum": this.data.subletCustomerCertNum,
          "subletCustomerName": this.data.subletCustomerName,
          "subletCustomerPhone": this.data.subletCustomerPhone,
          "surType": this.data.surType,
          "surrenderFid": this.data.surFid,
          surReasonType:this.data.surReasonType,
          surReason:this.data.surReason,
          isUpdate: this.$route.query.fromreleases == 1?1:0,//0 不修改  1 修改
          contractFid:this.contractId
        }
        epsbaseupdate(params).then(res => {
          let param={
            parentSurrenderFid:this.data.parentSurrenderFid,
            surFid:this.data.surFid,
            stockStatus:this.data.stockStatus,
            projectName:this.data.projectName,
            stockNumber:this.data.stockNumber,
            stockRentDate: this.data.stockRentDate,
          }
          // console.log(param)
          this.$emit('todelivery', param)
        }).catch(error => {

        })

      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      toNext() {
        this.$refs['formData'].validate(bool => {
          if (bool) {
            if (!this.stockRentDate) {
              this.$Message.info('请选择可出租日期');
              return;
            }
            this.epsbaseupdate()
          }
          else {
            this.$Message.info('请检查必选项');
          }
        })
      }
    },
    created() {
      this.contractId = this.$route.params.id
    }
  }
</script>

<style scoped>

  .ivu-form-item {
    margin-bottom: 15px;
  }

  .width250 {
    width: 350px;
  }

  .width150 {
    width: 200px;
  }

  .inputwidth {
    width: 80px;
  }

  .ivu-select-dropdown {
    top: 32px !important;
  }

  .inlineblock {
    display: inline-block;
  }

  .fixed {
    padding: 10px;
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 100%;

  }

  .a1 {
    text-align: center;
    margin-top: 30px;
  }

  .left, .right {
    display: inline-block;
    line-height: 2.5;

  }

  .left {
    width: 150px;
  }

  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }


</style>
